import * as React from 'react'
import PropTypes from 'prop-types'

const StarIcon = ({ width = 30, height = 29, color = '#FFE1C2' }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 30 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.624 28.001a1 1 0 01-.587-.188L15 21.986l-8.038 5.828a1 1 0 01-1.534-1.13l3.135-9.286-8.125-5.572a1 1 0 01.562-1.825h10.024l3.025-9.31a1 1 0 011.903 0l3.025 9.313h10.023a1 1 0 01.566 1.825l-8.128 5.569 3.133 9.283a1 1 0 01-.946 1.32z"
        fill={color}
      />
    </svg>
  )
}

StarIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  color: PropTypes.string,
}

export default React.memo(StarIcon)
